import { render, staticRenderFns } from "./ProductPriceSelect.vue?vue&type=template&id=2cda3c6e&"
import script from "./ProductPriceSelect.vue?vue&type=script&lang=js&"
export * from "./ProductPriceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports